import React from 'react';

// Material UI
import { StyledCircularProgress } from '../../styles/matieralui/Progress';

// TCC Styles
import { SmartContainer } from '../../styles/Containers'
import { StyledCaptureCollabIcon } from '../../assets/CaptureCollabIconSVG';
import icon from '../../assets/icon-black-green.png';
import styled, { keyframes } from 'styled-components';



export const FullScreenLoader = () => {
    return (
        <SmartContainer height="100vh" flex align="center" justify="center">
            <StyledCaptureCollabIcon />

        </SmartContainer>
    )
}